
















































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import Lives from '@/components/Lives.vue';
import {GameConfig} from '@/components/types/GameConfig';

enum Mode {
    Beginner = 0,
    Intermediate = 1,
    Expert = 2,
    Custom = 3,
}

@Component({
    components: {Lives}
})
export default class GameOptions extends Vue {
    @Prop() vsComputer!: boolean;
    @Prop() onPlayClick!: (gameConfig: GameConfig) => void;

    Mode = Mode;
    mode = Mode.Beginner;
    width = 0;
    height = 0;
    mines = 0;
    speed = 0;
    lives = 0;

    private modes = [
        {
            width: 30,
            height: 20,
            mines: 110,
            speed: 2,
            lives: 2,
        } as GameConfig,
        {
            width: 40,
            height: 25,
            mines: 230,
            speed: 5,
            lives: 3,
        } as GameConfig,
        {
            width: 50,
            height: 30,
            mines: 340,
            speed: 8,
            lives: 4,
        } as GameConfig,
    ];

    created(): void {
        this.setMode(Mode.Beginner);
    }

    setMode(mode: Mode): void {
        this.mode = mode;

        if (mode in this.modes) {
            const modeConfig = this.modes[mode as Mode];
            this.width = modeConfig.width;
            this.height = modeConfig.height;
            this.mines = modeConfig.mines;
            this.speed = modeConfig.speed;
            this.lives = modeConfig.lives;
        }
    }

    playClick(): void {
        // todo what to do with the buttons?
        const gameConfig: GameConfig = {
            width: this.width,
            height: this.height,
            mines: this.mines,
            speed: this.speed,
            lives: this.lives,
        };

        this.onPlayClick(gameConfig);
    }
}
